import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, CredentialsService } from 'src/app/core';
import { clearLocalStorage } from 'src/app/main/service/clear-localstorage';
import { ToastService } from 'src/app/main/bootstrap/toast/ToastService';
import { ApiService } from 'src/services/api.service';
import {
  EnableTemporaryOTPModalComponent
} from "../../two-factor/2fa-modals/enable-temporary-otp-modal/enable-temporary-otp-modal.component";
import {
  TemporaryOTPModalComponent
} from "../../two-factor/2fa-modals/temporary-otp-modal/temporary-otp-modal.component";
import {BsModalService} from "ngx-bootstrap/modal";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  showPassword = false;

  loading: boolean = false;
  submitted: boolean = false;
  returnUrl: string;
  errorMsg: string = 'default';

  error = '';

  errorMessage: string = "";
  loginForm: FormGroup;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private apiServices: ApiService,
              private authenticationService: AuthenticationService,
              private credentialsService: CredentialsService,
              private formBuilder: FormBuilder,
              private modal: BsModalService,
              private toastService: ToastService) {
    this.loginForm = this.initializeForm();
  }

  ngOnInit(): void {
    clearLocalStorage();
    localStorage.removeItem('accessToken');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('PortalUserRole')
    localStorage.clear();
    sessionStorage.clear();
    this.authenticationService.logout('EXPIRED')


  }

  initializeForm() {
    return this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', Validators.required],
      remember: ['']
    });
  }

  get loginFormControl() {
    return this.loginForm.controls;
  }

  //loginContext: LoginContext
  getLandingPage(response: any) {
    let roles = this.authenticationService.getGrantedAuthority(response);
    //let landing = "/company-registration/company-list";
    let landing = "/dashboard";
    if (roles.includes("CAC_CRP_DATA_ENTRY_OFFICER")) {
      landing = "/dashboard";
    } else {
      landing = "/company-registration/company-list";
    }
    return landing;
  }

  handleLogin() {

    if (!this.loginForm.valid) {
      alert('Invalid Form');
      return;
    };

    this.loading = true;
    const request = {
      authType: 'USERNAME',
      value: this.loginFormControl.username.value,
      username: this.loginFormControl.username.value,
      password: this.loginFormControl.password.value
    }

    let landingPage:any = "";

    this.authenticationService.loginWithTOTP(request)
      .subscribe((response) => {
        // landingPage = this.getLandingPage(response);
        const returnUrl = this.route.snapshot.queryParams.redirect;
          // || landingPage;
        // // this.router.navigate([url]);
        // window.location.href = url

        if (!response?.data?.portalUser?.isTotpEnabled) {
          this.modal.show(EnableTemporaryOTPModalComponent, {
            initialState: {
              props: {
                request,
                email: response?.data?.portalUser?.email || '',
                isPasswordReset: !!response?.data?.portalUser?.isPasswordReset,
                returnUrl
              }
            },
            class: 'modal-dialog-centered',
            animated: true,
            ignoreBackdropClick: true,
            keyboard: false,
            backdrop: 'static',
          });
        } else {
          this.modal.show(TemporaryOTPModalComponent, {
            initialState: {
              props: {
                request,
                returnUrl,
                onClose: () => {
                  this.submitted = false;
                  this.loading = false;
                  this.errorMessage = 'OTP Verification Cancelled'
                }
              }
            },
            class: 'modal-dialog-centered',
            animated: true,
            ignoreBackdropClick: true,
            keyboard: false,
            backdrop: 'static',
          });
        }

        // this.errorMessage = "";
        // if (!response) {
        //   this.router.navigate(['/login']);
        //   this.toastService.showDanger('Not Assign to Perform this Task!');
        //   this.loading = false;
        //   this.errorMessage = "Not Assign to Perform this Task!";
        //   return;
        // }
        //
        // this.loading = false;
        //
        // landingPage = this.getLandingPage(response);
        // const url = this.route.snapshot.queryParams.redirect || landingPage;
        // // this.router.navigate([url]);
        // window.location.href = url
      }, (err) => {
        this.loading = false;
        this.error = err?.error?.message || err?.message || 'Invalid username or password!';
      });


  }

  handleLoginOld() {
    this.loading = true;
    let request: any = {
      username: this.loginFormControl.username.value,
      password: this.loginFormControl.password.value
    }
    let remember: boolean = this.loginFormControl.remember.value;

    if (this.loginForm.valid) {
      let landingPage = "";
      this.authenticationService.login(request, remember)
        .subscribe((response) => {
          this.errorMessage = ""
          if (response == false) {
            this.router.navigate(['/login']);
            this.toastService.showDanger('Not Assign to Perform this Task!');
            this.loading = false;
            this.errorMessage = "Not Assign to Perform this Task!";
            return false;
          } else {
            this.loading = false;
            // this.errorMessage = "Username or password incorrect!";

            landingPage = this.getLandingPage(response);
            let url = this.route.snapshot.queryParams.redirect || landingPage;
            // this.router.navigate([url]);
            window.location.href = url
          }
        });

    }
  }

  togglePassword(){
    this.showPassword = !this.showPassword;
  }

}
